import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=76aa15eb&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=76aa15eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76aa15eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76aa15eb')) {
      api.createRecord('76aa15eb', component.options)
    } else {
      api.reload('76aa15eb', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=76aa15eb&scoped=true&", function () {
      api.rerender('76aa15eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4C2EbMGq4iy33/JS/comp/GuestBox.vue"
export default component.exports